import { Tag } from "antd";
import React from "react";

const FlagAdminRecommended = ({ isAdminRecommended }) => {
  return (
    <Tag
      bordered={false}
      color="red"
      style={{
        fontSize: 12,
        display: isAdminRecommended ? "block" : "none",
      }}
    >
      P
    </Tag>
  );
};

export default FlagAdminRecommended;
